import React from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/layout';
import Box from 'components/box';
import Title from 'components/title';
import { graphql } from 'gatsby';

const Index = ({ data }) => (
  <Layout>
    <Box>
      <Title as="h2" size="large">
        {data.homeJson.content.childMarkdownRemark.rawMarkdownBody}
        sdfklasjdfaksjlhdf
      </Title>
    </Box>
    <Box>
      <a href="https://instagram.com/yesrepeatno">
        <img src="icons8-instagram-50.png" alt="instagram" />
      </a>
      <a href="https://www.youtube.com/channel/UCR093bKhAIYXCJAYr-c34ow/">
        <img src="icons8-play-button-50.png" alt="YouTube" />
      </a>
      <a href="https://twitter.com/_yesrepeatno">
        <img src="icons8-twitter-50.png" alt="Twitter" />
      </a>
    </Box>
  </Layout>
);

Index.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Index;

export const query = graphql`
  query HomepageQuery {
    homeJson {
      title
      content {
        childMarkdownRemark {
          html
          rawMarkdownBody
        }
      }
      gallery {
        title
        copy
        image {
          childImageSharp {
            fluid(maxHeight: 500, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`;
